module.exports = __webpack_public_path__ + "img/tab.322ce652.png";